import some from 'lodash/some'

/**
 * Magento fallback until contentstack is fully live
 * TODO: Refactor out when contentstack is live.
 */
export const chipLabelFallback = {
  black_friday: 'common:black_friday',
  black_monday: 'common:black_friday',
  discount: '',
  free_delivery: 'all:FREE_DELIVERY',
  new: 'common:BADGE_NEW_LABEL',
  out_of_stock: 'cms:SOLD_OUT_LABEL',
  outlet: 'outlet',
  valentines_day: 'Valentines Day',
}
export const generateChipLabel = (label: string, type: string, variant: string, percentage?: number): string => {
  const isDiscount = (percentage || 0) > 0
  const displayPercentage = type !== 'new' && isDiscount
  const percentageLabel = displayPercentage ? `-${percentage}%` : ''
  const separator = label !== '' && displayPercentage ? ' ' : ''
  return variant === 'red'
    ? `${label}${separator}${percentageLabel}`
    : `${percentageLabel}${separator}${label}`
}

// TODO: Refactor when Contentstack desires control (Black / Red Variant).
export const getChipVariant = (type: string) => {
  const redVariants = ['discount', 'valentines_day', 'outlet']
  const found = some(redVariants, item => item === type.toLowerCase())
  return found ? 'red' : 'black'
}
